import type { AxiosError } from "axios";
import type { inferParserType } from "nuqs";
import { createSerializer, parseAsInteger } from "nuqs";
import useSWR from "swr";
import type { NskSwrErrorResponse, SwrReturnType } from "~/models/Api";
import type { PastDealList } from "~/models/PastDeal";
import { generatePath } from "~/utils/generatePath";

export const pastDealsPageParsers = {
	building_page: parseAsInteger.withDefault(1),
	room_page: parseAsInteger.withDefault(1)
};

const serializePastDealsPage = createSerializer(pastDealsPageParsers);

export const usePastDeals = (
	dealId: number | null,
	query: inferParserType<typeof pastDealsPageParsers>,
	onError?: (error: AxiosError<NskSwrErrorResponse>) => void
): SwrReturnType<PastDealList> => {
	const searchParams = serializePastDealsPage(query);
	const { data, mutate, error, isLoading } = useSWR<PastDealList>(
		dealId === null
			? null
			: `${generatePath("/deals/:deal_id/past_deals", { deal_id: dealId })}${searchParams}`,
		{ keepPreviousData: true, onError }
	);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
